import { TitleLink } from '@/types/title-link'
import { mkInternalNavLink, InternalNavLink } from '@/utils/internal-nav-link'

export const docsEndpointLinks: TitleLink[] = [
  {
    title: 'Trending Endpoint',
    link: '/docs/api/endpoint#trending',
  },
  {
    title: 'Search Endpoint',
    link: '/docs/api/endpoint#search',
  },
  {
    title: 'Translate Endpoint',
    link: '/docs/api/endpoint#translate',
  },
  {
    title: 'Random Endpoint',
    link: '/docs/api/endpoint#random',
  },
  {
    title: 'Action Register Endpoint',
    link: '/docs/api/endpoint#action-register',
  },
  {
    title: 'Random ID Endpoint',
    link: '/docs/api/endpoint#random-id',
  },
  {
    title: 'Get GIF by ID Endpoint',
    link: '/docs/api/endpoint#get-gif-by-id',
  },
  {
    title: 'Get GIFs by ID Endpoint',
    link: '/docs/api/endpoint#get-gifs-by-id',
  },
  {
    title: 'Upload Endpoint',
    link: '/docs/api/endpoint#upload',
  },
  {
    title: 'Categories',
    link: '/docs/api/endpoint#categories',
  },
  {
    title: 'Autocomplete',
    link: '/docs/api/endpoint#autocomplete',
  },
  {
    title: 'Channel Search Endpoint',
    link: '/docs/api/endpoint#channel-search',
  },
  {
    title: 'Search Suggestions',
    link: '/docs/api/endpoint#search-suggestions',
  },
  {
    title: 'Trending Search Terms',
    link: '/docs/api/endpoint#trending-search-terms',
  },
]

export const docsSchemaLinks: TitleLink[] = [
  {
    title: 'Gif Object',
    link: '/docs/api/schema#gif-object',
  },
  {
    title: 'Image Object',
    link: '/docs/api/schema#image-object',
  },
  {
    title: 'Meta Object',
    link: '/docs/api/schema#meta-object',
  },
  {
    title: 'Pagination Object',
    link: '/docs/api/schema#pagination-object',
  },
  {
    title: 'User Object',
    link: '/docs/api/schema#user-object',
  },
  {
    title: 'Random Id Object',
    link: '/docs/api/schema#random-id-object',
  },
  {
    title: 'Analytics Object',
    link: '/docs/api/schema#analytics-object',
  },
  {
    title: 'Category Object',
    link: '/docs/api/schema#category-object',
  },
  {
    title: 'Sub category Object',
    link: '/docs/api/schema#sub-category-object',
  },
  {
    title: 'Term Object',
    link: '/docs/api/schema#term-object',
  },
  {
    title: 'Channel Object',
    link: '/docs/api/schema#channel-object',
  },
]

export const docsSdkLinks: TitleLink[] = [
  {
    title: 'SDK Overview',
    link: '/docs/sdk',
  },
  {
    title: 'Content Types',
    link: '/docs/sdk#content-types',
  },
  {
    title: 'Customization',
    link: '/docs/sdk#grid',
  },
  {
    title: 'iOS SDK',
    link: '/docs/sdk#ios',
  },
  {
    title: 'Android SDK',
    link: '/docs/sdk#android',
  },
  {
    title: 'Web SDK',
    link: '/docs/sdk#web',
  },
  {
    title: 'React Native SDK',
    link: '/docs/sdk#react-native',
  },
  {
    title: 'Design Guidelines',
    link: '/docs/sdk#design-guidelines',
  },
  {
    title: 'App Store Submission',
    link: '/docs/sdk#data-collection',
  },
]

export const docsOptionalLinks: TitleLink[] = [
  {
    title: 'Rendition Guide',
    link: '/docs/optional-settings#rendition-guide',
  },
  {
    title: 'Language Support',
    link: '/docs/optional-settings#language-support',
  },
  {
    title: 'Rating System',
    link: '/docs/optional-settings#rating',
  },
]

export const docsTrustAndSafetyLinks: TitleLink[] = [
  {
    title: 'Safe Search Terms',
    link: '/docs/trust-and-safety#safe-search-terms',
  },
  {
    title: 'GIF Blocking Tool',
    link: '/docs/trust-and-safety#gif-blocking-tool',
  },
]

export const docsResourceLinks: TitleLink[] = [
  {
    title: 'Code Examples',
    link: '/docs/resource#code-examples',
  },
  {
    title: 'Support',
    link: '/docs/resource#support',
  },
  {
    title: 'API Explorer',
    link: 'https://developers.giphy.com/explorer/',
  },
]

export const docsApiLinks: TitleLink[] = [
  {
    title: 'API Quickstart Guide',
    link: '/docs/api#quick-start-guide',
  },
  {
    title: 'GIF & Sticker Endpoints',
    link: '/docs/api/endpoint#search',
  },
  {
    title: 'Schema Definitions',
    link: '/docs/api/schema#gif-object',
  },
  {
    title: 'Response Code',
    link: '/docs/api#response-codes',
  },
]

export const tosLinks: TitleLink[] = [
  {
    title: 'API Terms of Service',
    link: 'https://support.giphy.com/hc/en-us/articles/360028134111-GIPHY-API-Terms-of-Service',
  },
  {
    title: 'SDK License Agreement',
    link: 'https://support.giphy.com/hc/en-us/articles/360027858552-Giphy-SDK-License-Agreement',
  },
  {
    title: 'Community Guidelines',
    link: 'https://support.giphy.com/hc/en-us/articles/360020286811-GIPHY-Community-Guidelines',
  },
  {
    title: 'Privacy Policy',
    link: 'https://support.giphy.com/hc/en-us/articles/360032872931-GIPHY-Privacy-Policy',
  },
  {
    title: 'Copyright',
    link: 'https://support.giphy.com/hc/en-us/articles/360020287091-GIPHY-DMCA-Copyright-Policy',
  },
]

export const headerLinks = [
  {
    item: {
      title: 'Docs',
      link: '/docs',
    },
    hasDropdown: true,
  },
  {
    item: {
      title: 'Dashboard',
      link: '/dashboard',
    },
  },
  {
    item: {
      title: 'FAQs',
      link: '/faq',
    },
  },
  {
    item: {
      title: 'Blog',
      link: 'https://engineering.giphy.com/',
    },
  },
]

export const docsClipsLinksIndex = {
  whatAreClips: mkInternalNavLink({
    title: 'What are Clips?',
    pathname: '/docs/clips',
  }),
  library: mkInternalNavLink({
    title: 'Library',
    pathname: '/docs/clips',
    hash: 'library',
  }),
  contentSafety: mkInternalNavLink({
    title: 'Content Safety',
    pathname: '/docs/clips',
    hash: 'content-safety',
  }),
  endpoints: mkInternalNavLink({
    title: 'Clips Endpoints',
    pathname: '/docs/clips/endpoint',
  }),
  responseSchema: mkInternalNavLink({
    title: 'Clips Response Schema',
    pathname: '/docs/clips/schema',
  }),
  videoObjectSchema: mkInternalNavLink({
    title: 'Video Object Schema',
    pathname: '/docs/clips/schema',
    hash: 'video-object',
  }),
  examples: mkInternalNavLink({
    title: 'Examples',
    pathname: '/docs/clips/examples',
  }),
  searchEndpoint: mkInternalNavLink({
    title: 'GIPHY Clips Search Endpoint',
    pathname: '/docs/clips/endpoint',
    hash: 'search',
  }),
  trendingEndpoint: mkInternalNavLink({
    title: 'GIPHY Clips Trending Endpoint',
    pathname: '/docs/clips/endpoint',
    hash: 'trending',
  }),
  contentByIDEndpoint: mkInternalNavLink({
    title: 'Get Content by ID Endpoint',
    pathname: '/docs/clips/endpoint',
    hash: 'get-by-id',
  }),
  contentByMultipleIDsEndpoint: mkInternalNavLink({
    title: 'Get Content by Multiple IDs Endpoint',
    pathname: '/docs/clips/endpoint',
    hash: 'get-by-ids',
  }),
} as const

export const docsClipsLinks: InternalNavLink[] = [
  docsClipsLinksIndex.whatAreClips,
  docsClipsLinksIndex.library,
  docsClipsLinksIndex.contentSafety,
  docsClipsLinksIndex.endpoints,
  docsClipsLinksIndex.responseSchema,
  docsClipsLinksIndex.examples,
]

export const docsClipsEndpointsLinks: InternalNavLink[] = [
  docsClipsLinksIndex.searchEndpoint,
  docsClipsLinksIndex.trendingEndpoint,
  docsClipsLinksIndex.contentByIDEndpoint,
  docsClipsLinksIndex.contentByMultipleIDsEndpoint,
]

export const docsClipsSidebarLinks: (InternalNavLink & { children?: InternalNavLink[] })[] = [
  docsClipsLinksIndex.whatAreClips,
  docsClipsLinksIndex.library,
  docsClipsLinksIndex.contentSafety,
  {
    ...docsClipsLinksIndex.endpoints,
    children: docsClipsEndpointsLinks,
  },
  docsClipsLinksIndex.responseSchema,
  docsClipsLinksIndex.examples,
]
